export default __webpack_public_path__ + "static/media/woman-account.84732a0a.webp";